export default __webpack_public_path__ + "static/media/img-hero-mobile-01-classic.3f0191a2.jpg";